// Calling the hub's logged-in Edge Functions (docs/data-model.md, section 10.1) with the member's
// session: supabase-js sends their access token and the publishable key. Every refusal is
// {"error": "<code>", "message": "<the line to show>"}, sometimes with more fields (change-email's
// attempts_left); it comes back as a HubFunctionError carrying all of it, so a screen shows the
// function's own line rather than one of its own.
import { supabase } from './supabase.js'

const FALLBACK = 'Something went wrong. Try again.'
// the functions' own not_logged_in line (_shared/member.ts), for every screen: Supabase's gateway
// refuses a token it can't read with words of its own ("Invalid JWT"), which members never see
export const LOGIN_RAN_OUT = 'Your login has run out. Log in again.'

export class HubFunctionError extends Error {
  // code: the function's error code (viewing_as, too_short, ...), or 'failed' when there was no
  // answer to read; status: the HTTP status, 0 when the request never got one; message: the line
  // to show; body: the whole answer, for any extra field
  constructor(code, status, message = FALLBACK, body = null) {
    super(message)
    this.code = code
    this.status = status
    this.body = body
  }
}

export async function callHubFunction(name, body = {}) {
  const { data, error } = await supabase.functions.invoke(name, { body })
  if (!error) return data
  let code = 'failed'
  let status = 0
  let message = FALLBACK
  let answer = null
  const res = error.context
  if (res && typeof res.json === 'function') {
    status = res.status
    try {
      answer = await res.json()
      code = answer?.error || code
      // Supabase's own gateway refuses a token it can't read with {"code", "message"}
      if (!answer?.error && status === 401) code = 'not_logged_in'
      if (typeof answer?.message === 'string' && answer.message) message = answer.message
    } catch { /* not JSON */ }
  }
  if (code === 'not_logged_in') message = LOGIN_RAN_OUT
  throw new HubFunctionError(code, status, message, answer)
}
